import { Api } from "@mui/icons-material";
import { PropertyType } from "../types/PropertyType";
import { getServiceIcon } from "./icons";

const defaultServiceSettings: {[id: string]: IServiceBlueprint} = {
    "fortnox-invoice-pdf": {
        id: "fortnox-invoice-pdf",
        title: "Fortnox PDF Invoices",
        icon: getServiceIcon("fortnox-invoice-pdf"),
        properties: [
            {
                id: "tokens",
                title: "Access Tokens",
                type: PropertyType.UUID,
                secret: false,
                unique: true,
                create: true,
                edit: false,
                array: {
                    unique: true,
                    addOnEdit: false
                }
            }
        ]
    },
    "hogia-invoice-pdf": {
        id: "hogia-invoice-pdf",
        title: "Hogia PDF Invoices",
        icon: getServiceIcon("hogia-invoice-pdf"),
        properties: [
            {
                id: "companyId",
                title: "Company ID",
                type: PropertyType.UUID,
                secret: false,
                create: true,
                edit: true
            },
            {
                id: "clientId",
                title: "Client ID",
                type: PropertyType.UUID,
                secret: false,
                create: true,
                edit: true
            },
            {
                id: "clientSecret",
                title: "Client Secret",
                type: PropertyType.PASSWORD,
                secret: true,
                create: true,
                edit: true
            }
        ]
    },
    "business-central-invoice-pdf": {
        id: "business-central-invoice-pdf",
        title: "Business Central PDF Invoices",
        icon: getServiceIcon("business-central-invoice-pdf"),
        properties: [
            {
                id: "tenantId",
                title: "Tenant ID",
                type: PropertyType.TEXT,
                secret: false,
                create: true,
                edit: true
            },
            {
                id: "companyId",
                title: "Company ID",
                type: PropertyType.TEXT,
                secret: false,
                create: true,
                edit: true
            },
            {
                id: "clientId",
                title: "Client ID",
                type: PropertyType.TEXT,
                secret: false,
                create: true,
                edit: true
            },
            {
                id: "clientSecret",
                title: "Client Secret",
                type: PropertyType.PASSWORD,
                secret: true,
                create: true,
                edit: true
            }
        ]
    },
    "fortnox-invoice-pdf-v2": {
        id: "fortnox-invoice-pdf-v2",
        title: "Fortnox PDF Invoices v2 (OAuth2)",
        icon: getServiceIcon("fortnox-invoice-pdf-v2"),
        properties: [
            {
                id: "refreshToken",
                title: "Refresh Token (optional)",
                type: PropertyType.TEXT,
                secret: true,
                unique: false,
                create: true,
                edit: false
            }
        ]
    },
}

export const ServiceSettings: IServiceSettings = {
    services: defaultServiceSettings,
    getSettings: (id: string)=>defaultServiceSettings[id],
    getDefaultState: (id: string)=>(defaultServiceSettings[id] ? {
        ...defaultServiceSettings[id],
        title: undefined
    } : {}),
    FallbackIcon: Api,
}